import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './app/App';
import { store } from './redux';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(

<StrictMode>
	<Provider store={store}>
			<App />
	</Provider>
</StrictMode>

);

serviceWorker.register(new URL(globalThis.location.href).searchParams.has('debug'));
